import "babel-polyfill";

import Vue from 'vue'
import vmApp from './application/index.vue'

new Vue(vmApp).$mount('#application')



// WEBPACK FOOTER //
// ./src/main.js